<div class="col-md-12 action-buttons text-right upload-button">
    <div class="upload-guide-info" [innerHTML]="l('UserUploadGuide')"></div>
    <div class="upload-input">
        <button (click)="downloadUserTemplate()" class="btn btn-primary">{{l("DownloadUserTemplate")}}</button>
        <button [buttonBusy]="saving" (click)="browseFiles()" class="btn btn-primary" style="margin-left: 0px;">{{l("UploadNewUsers")}}</button>

        <input type="file" id="getFile" style="display:none;" [(ngModel)]="selectedFile" (ngModelChange)="uploadFile()" />
    </div>
</div>